// Firebase configuration using individual packages
import { initializeApp, getApps, getApp } from '@firebase/app';
import {
  browserLocalPersistence,
  browserSessionPersistence,
  getAuth,
  indexedDBLocalPersistence,
  initializeAuth,
  inMemoryPersistence,
} from '@firebase/auth';
import { getFirestore } from '@firebase/firestore';
import { getStorage } from '@firebase/storage';
import { getFunctions } from '@firebase/functions';

function resolveAuthDomain(configuredAuthDomain: string): string {
  if (
    typeof window !== 'undefined' &&
    window.location.hostname === 'micomms.me' &&
    configuredAuthDomain === 'micomms.firebaseapp.com'
  ) {
    return 'micomms.me';
  }

  return configuredAuthDomain;
}

// Your web app's Firebase configuration
const configuredAuthDomain = process.env.NEXT_PUBLIC_FIREBASE_AUTH_DOMAIN || "demo-project.firebaseapp.com";
const firebaseConfig = {
  apiKey: process.env.NEXT_PUBLIC_FIREBASE_API_KEY || "demo-key",
  authDomain: resolveAuthDomain(configuredAuthDomain),
  projectId: process.env.NEXT_PUBLIC_FIREBASE_PROJECT_ID || "demo-project",
  storageBucket: process.env.NEXT_PUBLIC_FIREBASE_STORAGE_BUCKET || "micomms.firebasestorage.app",
  messagingSenderId: process.env.NEXT_PUBLIC_FIREBASE_MESSAGING_SENDER_ID || "123456789",
  appId: process.env.NEXT_PUBLIC_FIREBASE_APP_ID || "1:123456789:web:abcdef",
  measurementId: process.env.NEXT_PUBLIC_FIREBASE_MEASUREMENT_ID
};

// Initialize Firebase only if it hasn't been initialized yet
let app;
if (getApps().length === 0) {
  app = initializeApp(firebaseConfig);
} else {
  app = getApp();
}

// Initialize services
const auth =
  typeof window === 'undefined'
    ? getAuth(app)
    : (() => {
        try {
          return initializeAuth(app, {
            persistence: [
              indexedDBLocalPersistence,
              browserLocalPersistence,
              browserSessionPersistence,
              inMemoryPersistence,
            ],
          });
        } catch {
          return getAuth(app);
        }
      })();
const db = getFirestore(app);
const storage = getStorage(app);
const functions = getFunctions(app, 'us-central1');

export { app, auth, db, storage, functions };
